import React, { Component } from 'react';
import { Button, Text, Icon } from '../../Atoms';
import { connect } from "react-redux"
import { TemplateRembourcementHistory, TemplateSimulateurRembourcementScreen1, TemplateSimulateurRembourcementScreen2, TemplateSimulateurRembourcementScreen3, TemplateSimulateurRembourcementScreen4 } from '../../Templates'
const BENEF_LIST = [{ text: 'Eva ROBIN', value: '' }, { text: 'Paul ROBIN', value: '' }, { text: 'Juliette ROBIN', value: '' }]
const ACTES_LIST = [
    {
        text: 'Soins courants : consultation, visites, analyse, radiologie, auxiliaires médicaux, medecine douce',
        value: {
            category: 'Soins courants',
            description: 'consultation, visites, analyse, radiologie, auxiliaires médicaux, medecine douce'
        }
    },
    {
        text: 'Appareillage : petit appareillage, prothèses auditives',
        value: {
            category: 'Appareillage',
            description: 'petit appareillage, prothèses auditives'
        }
    },
    {
        text: 'Hospitalisation : forfait journalier, chambre particulière, frais de séjours, honoraires',
        value: {
            category: 'Hospitalisation',
            description: 'forfait journalier, chambre particulière, frais de séjours, honoraires'
        }
    },
    {
        text: 'Optique : lentilles, chirurgie, verre et monture (sur devis)',
        value: {
            category: 'Optique',
            description: 'lentilles, chirurgie, verre et monture (sur devis)'
        }
    },
    {
        text: 'Dentaire : soins, couronne, appareil, Inlay Core, orthodontie',
        value: {
            category: 'Dentaire',
            description: 'soins, couronne, appareil, Inlay Core, orthodontie'
        }
    },

]
const ACTE_SOINS_COURANTS = [{ text: 'Consultations', value: '' }, { text: 'Visites', value: '' }, { text: 'Analyse', value: '' }, { text: 'Radiologie', value: '' }, { text: 'Auxiliaires médicaux', value: '' }, { text: 'Médecine douce', value: '' }]
const ACTE_SOINS_DENTAIRE = [{ text: 'Soins', value: '' }, { text: 'Couronne', value: '' }, { text: 'Appareil dentaire', value: '' }, { text: 'Inlay Core', value: '' }, { text: 'Orthodontie', value: '' }]
const ACTE_SOINS_HOSPI = [{ text: 'Forfait journalier', value: '' }, { text: 'Chambre particulière', value: '' }, { text: 'Frais de séjours', value: '' }, { text: 'Honoraires', value: '' }]
const ACTE_SOINS_OPTIQUE = [{ text: 'Lentilles', value: '' }, { text: 'Chirurgie défauts visuels', value: '' }, { text: 'Verre et monture (sur devis)', value: '' }]
const ACTE_SOINS_APPAREAL = [{ text: 'Petit appareillage', value: '' }, { text: 'Prothèses auditives', value: '' }]
class SimulateurDeRemboursement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedActesListItem: {},
            selectedBenef: {},
            selectedActes: {},
            step: 1,
            actesSoinsList: [],
            actesDansParcoursDeSoins: null,
            secteurConventionne: null,
            optam: null,
            price: '',
            unkownPrice: false,
            interventionSecuriterSocial: null,
            dentaireInputValue: '',
            screen: 'Simuler'
        };
    }

    renderListActesOptions = (option, selected, submitChoice) => {
        return (
            option.map(el => {
                let classNameOption = ''
                if (selected === el.text) {
                    classNameOption = 'selected-actes-option-container-simulateur-remboursement'
                } else {
                    classNameOption = 'select-option-container-simulateur-remboursement'
                }
                return (
                    <div className={classNameOption} onClick={() => submitChoice(el)} >
                        <span>{`${el.value.category} : `}</span>
                        {el.value.description}
                    </div>
                )
            }
            )
        )
    }

    onChangeSelectedActesListItem = (value) => {
        let actesChoices = []
        if (value.value.category === 'Soins courants') {
            actesChoices = ACTE_SOINS_COURANTS
        } else if (value.value.category === 'Dentaire') {
            actesChoices = ACTE_SOINS_DENTAIRE
        } else if (value.value.category === 'Appareillage') {
            actesChoices = ACTE_SOINS_APPAREAL
        } else if (value.value.category === 'Hospitalisation') {
            actesChoices = ACTE_SOINS_HOSPI
        } else if (value.value.category === 'Optique') {
            actesChoices = ACTE_SOINS_OPTIQUE
        }
        this.setState({
            selectedActesListItem: value,
            selectedActes: {},
            actesSoinsList: actesChoices
        })
    }

    onChangeBenef = (value) => {
        this.setState({
            selectedBenef: value
        })
    }

    onChangeActes = (value) => {
        this.setState({
            selectedActes: value
        })
    }

    nextStep = (step) => {
        if (step === 1) {
            if (this.state.selectedActesListItem.text && this.state.selectedBenef.text && this.state.selectedActes.text) {
                this.setState({
                    step: step + 1
                })
            }
        } else if (step === 2) {
            if (this.state.price !== '' || this.state.unkownPrice) {
                if (this.state.unkownPrice) {
                    this.setState({
                        step: 4
                    })
                } else if (this.state.selectedActesListItem.value.category === 'Dentaire') {
                    this.setState({
                        step: 3
                    })
                } else {
                    this.setState({
                        step: 4
                    })
                }
            }
        } else {
            this.setState({
                step: step + 1
            })
        }

    }

    onChangeBtnRadioStep2 = (key, value) => {
        this.setState({
            [key]: value
        })
    }

    onChangePrice = (value) => {
        this.setState({
            price: value,
            unkownPrice: false
        })
    }

    onChangeUnkonwnPrice = (value) => {
        if (value) {
            this.setState({
                price: ''
            })
        }
        this.setState({
            unkownPrice: value
        })
    }

    onChangeDentaireInput = (value) => {
        this.setState({
            dentaireInputValue: value
        })
    }

    onChangeScreens = (value) => {
        this.setState({
            selectedActesListItem: {},
            selectedBenef: {},
            selectedActes: {},
            step: 1,
            actesSoinsList: [],
            actesDansParcoursDeSoins: null,
            secteurConventionne: null,
            optam: null,
            price: '',
            unkownPrice: false,
            interventionSecuriterSocial: null,
            dentaireInputValue: '',
            screen: value
        })
    }

    renderScreens = () => {
        if (this.state.screen === 'Simuler') {
            return (
                <>
                    {this.state.step === 1 &&
                        <TemplateSimulateurRembourcementScreen1
                            benefList={BENEF_LIST}
                            actesList={ACTES_LIST}
                            actesSoinsList={this.state.actesSoinsList}
                            {...this}
                            {...this.state}
                        />}
                    {this.state.step === 2 &&
                        <TemplateSimulateurRembourcementScreen2
                            {...this}
                            {...this.state}
                        />}
                    {this.state.step === 3 &&
                        <TemplateSimulateurRembourcementScreen3
                            {...this}
                            {...this.state}
                        />}
                    {this.state.step === 4 &&
                        <TemplateSimulateurRembourcementScreen4
                            {...this}
                            {...this.state}
                        />}
                </>
            )
        } else {
            return (
               <TemplateRembourcementHistory/>
            );
        }
    }

    classNameContainer = () => {
        if (this.state.screen === 'Historique' && window.innerWidth <= 768) {
            if (this.props.sideBar) {
                return 'remboursement-width-sibe-bar-open'
            } else {
                return 'remboursement-width'
            }

        } else {
            return 'cartetp-container'
        }
    }

    render() {
        return (
            <>
                <div className={`template-scroll ${this.classNameContainer()}`}>
                    <Text
                        text="Simulateur de remboursement" type='h4'
                        className='cartetp-header-container'
                    />
                    <div className={`simulateur-remboursement-type ${this.state.screen === 'Historique' && 'extra-padding-simulateur-remboursement-type'}`} >
                        <Button
                            text='Simuler'
                            className={this.state.screen === 'Simuler' ? 'btn-radio-simulateur-remboursement-selected' : 'btn-radio-simulateur-remboursement-unselected'}
                            {...(this.state.screen === 'Simuler' && { boxShadow: true })}
                            onClick={() => this.onChangeScreens('Simuler')}
                        />
                        <Button
                            text='Historique'
                            className={this.state.screen === 'Historique' ? 'btn-radio-simulateur-remboursement-selected' : 'btn-radio-simulateur-remboursement-unselected'}
                            {...(this.state.screen === 'Historique' && { boxShadow: true })}
                            onClick={() => this.onChangeScreens('Historique')}
                        />
                    </div>
                    {this.renderScreens()}
                </div>
            </>
        );

    }
}
const mapStateToProps = (state) => ({
    sideBar: state.sideBar.open
});
export default connect(mapStateToProps, null)(SimulateurDeRemboursement);
